import React from "react";
import styled from "styled-components";
import { remCalc } from "../../utils/helpers";

const StyledCircle = styled(
  ({ fontSize, ...rest }) => (
    <div {...rest} />
  )
)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${props => remCalc(props.size)};
  height: ${props => remCalc(props.size)};
  background-color: ${props => props.bg};
  position: relative;

  p {
    color: ${props => props.color};
    font-size: ${props => remCalc(props.fontSize)};
    font-weight: bold;
  }
`;

StyledCircle.defaultProps = {
  bg: "#F7F7F7",
};

function CircleNumber({ text, ...otherProps }) {
  return (
    <StyledCircle {...otherProps}>
      <p>{text}</p>

      <div className="circle-number-indicator" />
    </StyledCircle>
  );
}

export default CircleNumber;
